module.exports = __webpack_public_path__ + "static/lifetime-fitness-silver-membership-icon-656aa361984360d94e4c87922ae5fc41.svg";